import React from 'react';
import { formatPoStatus } from '../services/supplierApi';

const STATUS_CLASS: Record<string, string> = {
  PENDING_SUPPLIER: 'sp-status--warning',
  SUPPLIER_PROPOSED: 'sp-status--info',
  APPROVED: 'sp-status--success',
  DISPATCHED: 'sp-status--info',
  PARTIALLY_RECEIVED: 'sp-status--muted',
  RECEIVED: 'sp-status--success',
  REJECTED: 'sp-status--danger',
  CANCELLED: 'sp-status--muted',
  DRAFT: 'sp-status--muted',
  PORTAL_ACTIVE: 'sp-status--success',
  INVITE_SENT: 'sp-status--info',
  NO_CONTACT: 'sp-status--muted',
};

type SupplierStatusBadgeProps = {
  status: string;
  label?: string;
};

const SupplierStatusBadge: React.FC<SupplierStatusBadgeProps> = ({ status, label }) => (
  <span className={`sp-status ${STATUS_CLASS[status] || 'sp-status--muted'}`}>
    {label || formatPoStatus(status)}
  </span>
);

export default SupplierStatusBadge;
